/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubscriptionAndPaymentDetailsResponse } from '../models/SubscriptionAndPaymentDetailsResponse';
import type { SubscriptionDto } from '../models/SubscriptionDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SubscriptionRestControllerService {
  /**
   * getSubscription
   * @returns SubscriptionAndPaymentDetailsResponse OK
   * @throws ApiError
   */
  public static getSubscriptionUsingGet({
    termId,
  }: {
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<SubscriptionAndPaymentDetailsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/subscription',
      query: {
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * changeSubscriptionPlan
   * @returns SubscriptionDto OK
   * @returns any Created
   * @throws ApiError
   */
  public static changeSubscriptionPlanUsingPut({
    newPlan,
    termId,
  }: {
    /**
     * newPlan
     */
    newPlan: 'PREMIUM' | 'STANDARD' | 'STARTER';
    /**
     * termId
     */
    termId: string;
  }): CancelablePromise<SubscriptionDto | any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/subscription/change-plan',
      query: {
        newPlan: newPlan,
        termId: termId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
